// eslint-disable-next-line jira/filename-case, jira/restricted/@atlassian/react-sweet-state
import {
	createHook,
	type Action,
	type BoundActions,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import type { EntityLimitType, EntityLimits } from './EntityLimitType.types.tsx';
import { EntityLimitsStore, type Actions } from './EntityLimitsContainer.tsx';
import type { Props, State } from './State.types.tsx';
import { getEntityLimits } from './getEntityLimits.tsx';

export const useEntityLimits: HookFunction<
	EntityLimits | null,
	BoundActions<
		State,
		{
			readonly loadEntityLimits: () => Action<State, Props>;
		}
	>,
	void
> = createHook<State, Actions, EntityLimits | null>(EntityLimitsStore, {
	selector: getEntityLimits,
});

// Get the limit for a specific entity type
export const useEntityLimitsByType = (limitType: EntityLimitType): number | null => {
	const [entityLimits] = useEntityLimits();
	return entityLimits?.[limitType] ?? null;
};
